// Toggles the desktop sidebar between expanded (icon + label) and collapsed
// (icon-only) by flipping a `sidebar-collapsed` class on <html> and persisting
// the choice in localStorage. The class is applied before first paint by an
// inline script in root.html.heex to avoid a flash; this hook keeps it in sync
// on toggle and gates the per-item tooltips so they only show when collapsed.
const STORAGE_KEY = "sidebar-collapsed";

function syncTooltips(collapsed) {
  document.querySelectorAll("[data-sidebar-tooltip]").forEach((el) => {
    if (el._tippy) {
      collapsed ? el._tippy.enable() : el._tippy.disable();
    }
  });
}

export const SidebarCollapse = {
  mounted() {
    // Tooltip hooks may mount after this one, so apply the initial gating on the
    // next frame once their tippy instances exist.
    requestAnimationFrame(() =>
      syncTooltips(document.documentElement.classList.contains("sidebar-collapsed")),
    );

    this.setCollapsed = (collapsed) => {
      document.documentElement.classList.toggle("sidebar-collapsed", collapsed);
      try {
        localStorage.setItem(STORAGE_KEY, collapsed ? "true" : "false");
      } catch {
        // localStorage may be unavailable (e.g. private mode); ignore.
      }
      syncTooltips(collapsed);
      // SidebarNav listens for this rather than watching the <html> class list.
      window.dispatchEvent(new CustomEvent("sidebar:collapsed", { detail: { collapsed } }));
    };

    this.handleClick = () => {
      this.setCollapsed(!document.documentElement.classList.contains("sidebar-collapsed"));
    };

    // Clicking a group in the collapsed rail expands into it, so the rail is
    // never a dead end for anyone who can't hover.
    this.handleExpand = () => this.setCollapsed(false);

    this.el.addEventListener("click", this.handleClick);
    window.addEventListener("sidebar:expand", this.handleExpand);
  },

  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
    window.removeEventListener("sidebar:expand", this.handleExpand);
  },
};
